import { PositionsPageHeader } from '@pages/Employees/Positions/components/PositionsPageHeader';

import { Positions } from '@pages/Employees/Positions/Positions.main';

export { Positions, PositionsPageHeader };
